import React from "react";
import LandingNavbar from "./LandingNavbar";
import HeroSection from "./heroSection";
import ClickPromptingSection from "./ClickPromptingSection";
import WhoItIsFor from "./whoItIsFor";
import ComparisonSection from "./ComparisonSection";
import PhasesSection from "./PhasesSection";
import ShowcaseSection from "./ShowcaseSection";
import PricingSection from "./PricingSection";
import TestimonialsSection from "./TestimonialsSection";
import FaqSection from "./FaqSection";
import FinalCtaSection from "./FinalCtaSection";
import FooterSection from "./FooterSection";

export const LandingPageNew = () => {
  return (
    <div className="relative w-full min-h-screen bg-[#05070a] text-white font-sora selection:bg-[#62FAE3] selection:text-[#05070a] overflow-x-hidden">
      {/* Floating Navbar */}
      <LandingNavbar />

      {/* Page Sections */}
      <HeroSection />
      <ClickPromptingSection />
      <WhoItIsFor />
      <ComparisonSection />
      <PhasesSection />
      <ShowcaseSection />
      <PricingSection />
      <TestimonialsSection />
      <FaqSection />
      <FinalCtaSection />
      <FooterSection />
    </div>
  );
};

export default LandingPageNew;
